<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.liveFeed.tagName`),
      tagLink: `${searchResult.link}/live-feed`,
    }"
    class="live-feed-card result-card"
  >
    <template #preview>
      <div
        v-if="searchResult.live_feed_images[0]?.image_url"
        class="preview-image"
      >
        <img
          :src="searchResult.live_feed_images[0].image_url"
          :alt="searchResult.live_feed_images[0]?.caption"
        />
      </div>
      <div
        v-else
        class="preview-fallback"
      >
        <Icon
          name="lucide:newspaper"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="`${searchResult.link}/live-feed#${searchResult.id}`"
        class="title"
        >{{ searchResult.type === 'article' ? searchResult.title : searchResult.status }}</a
      >
      <div
        v-if="searchResult.type === 'article' && searchResult.snippet"
        class="snippet"
      >
        {{ searchResult.snippet }}
      </div>
      <div
        v-if="searchResult.publish_date"
        class="dates-and-times"
      >
        <div class="published-at">{{ $t('search.forms.published') }}: {{ formattedDateAndTime }}</div>
        <div class="updated-at"></div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { computed } from 'vue';
import { monthDayYear } from '../../../helpers/date-utils';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
});

const formattedDateAndTime = computed(() => {
  return monthDayYear(props.searchResult.publish_date) || '';
});
</script>

<style scoped>
.live-feed-card {
  --background-color: #f3fafc;
  --text-color: #0592cc;
}
</style>
